export enum ADividerOrientation {
  Horizontal = 'Horizontal',
  Vertical = 'Vertical',
}

export interface ADividerProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: ADividerOrientation;
}
